import { trackEvent } from 'dibs-tracking';
import { graphql, useFragment } from 'react-relay';
import { dibsLazyClient } from 'dibs-lazy/src/dibsLazyClient';
import { FC, useState, Dispatch, SetStateAction, Suspense } from 'react';

// components
import { PdpSharedDetail, PdpSharedDetailProps } from './PdpSharedDetail';

// types
import { PdpSharedDetailCondition_item$key as Item } from './__generated__/PdpSharedDetailCondition_item.graphql';

const PdpSharedConditionModal = dibsLazyClient(
    () =>
        import(
            /* webpackChunkName: "PdpSharedConditionModalWrapper" */ '../../PdpSharedModals/PdpSharedConditionModal/PdpSharedConditionModalWrapper'
        )
);

const openConditionModal = (setModalOpen: Dispatch<SetStateAction<boolean>>): void => {
    trackEvent(
        {
            category: 'product',
            action: 'view condition descriptions clicked',
        },
        null
    );

    setModalOpen(true);
};

const itemQuery = graphql`
    fragment PdpSharedDetailCondition_item on Item {
        serviceId
    }
`;
type Props = Exclude<PdpSharedDetailProps, 'selectedSkuId'> & {
    item: Item;
};

export const PdpSharedDetailCondition: FC<Props> = ({ item: itemRef, ...props }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const item = useFragment(itemQuery, itemRef);
    const itemId = item.serviceId;

    return (
        <>
            <PdpSharedDetail
                {...props}
                onClickMap={{
                    condition: {
                        clickFn: () => openConditionModal(setModalOpen),
                        dataTn: 'open-condition-modal',
                    },
                }}
            />
            <Suspense fallback={null}>
                {modalOpen && itemId && (
                    <PdpSharedConditionModal
                        itemId={itemId}
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                    />
                )}
            </Suspense>
        </>
    );
};
